export { CarComplectation } from './CarComplectation';
